export default () => ({
    count: 0, 
    setCount(items) {
        if (JSON.stringify(items) === '{}') {
            fetch('/?view=cart')
            .then(response => response.text())
            .then(cartData => {
                var el = document.createElement('div');
                el.innerHTML = cartData;
                const element = el.querySelector('[data-options]');

                if (element) {
                    this.count = JSON.parse(element.innerHTML).item_count;
                }
            })
        } else {
            this.count = items;
        }
    }
});